export default "__VITE_ASSET__DJM6r2G___"